<template>
  <div class="inner-content">
    <slot></slot>
  </div>
</template>

<style lang="scss">
@import './inner-content.scss';
</style>
